renderRelated();


// recommendations
function renderRelated() {
  if (window.ISCartItems && window.ISCartItems.length > 0) {
    const section = document.querySelector('.is-cart-related .swiper-wrapper');
    console.log(window.ISCartItems);    
    let recommendations = [];
    let uniqueRecommendationIds = new Set();
    let fetchPromises = window.ISCartItems.map(item => {
    return fetch(window.Shopify.routes.root + `recommendations/products?product_id=${item}&limit=10&section_id=is-cart-recommended&intent=related`)
      .then(response => response.text())
      .then((text) => {
          const parsedHTML = new DOMParser().parseFromString(text, 'text/html');
          const elements = parsedHTML.querySelectorAll('.recommendation-product');
          elements.forEach(e => {
            const productId = e.getAttribute('data-id');
            if (productId && !uniqueRecommendationIds.has(productId) && !window.ISCartItems.includes(productId)) {
              uniqueRecommendationIds.add(productId);
              recommendations.push(e);
            }
          });
      });
    });

    Promise.all(fetchPromises)
    .then(() => {
      // console.log(recommendations);
      const div = document.createElement('div');
      recommendations.forEach((e, i) => {
        if (i < 20) {
          div.appendChild(e);
        }
      })
      section.innerHTML = '';
      section.innerHTML = div.innerHTML;
      relatedSlider();
    })
    .catch(error => {
      console.error('Error fetching recommendations:', error);
    });
  }
}

window.addEventListener('click', function(evt){
  if (evt.target.hasAttribute('related-add-cart')) {
    evt.target.form.submit();
  }
})

function relatedSlider() {
  const section = document.querySelector('.is-cart-related');
  const swiper = new Swiper(section.querySelector('.swiper'), {
    zoom: true,
    loop: true,
    slidesPerView: 1,
    centeredSlides: false,
    spaceBetween: 10,
    autoHeight: true,
    dots: true,
    allowTouchMove: false,
    navigation: {
      prevEl: section.querySelector('.prev'),
      nextEl: section.querySelector('.next')
    },
    pagination: {
      el: section.querySelector('.pagination'),
      clickable: true
    },
    breakpoints: {
      991: {
        slidesPerView: 4
      },
      491: {
        slidesPerView: 2
      }
    }
  })
}

/*****************/
$(document).ready(function(){
  // "More Info" / "REQUEST INFO" buttons now scroll to the embedded Hulk license form (page-level, not popup).
  $('.cstm-display_app_form_popup a.button, .cstm-display_app_form_popup a.link').click(function (e) {
      e.preventDefault();
      var f = document.getElementById('license-form');
      if (f) { f.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
});